import {ReactNode} from 'react';
import patient from '@legit-health/svg-images/images/patient.svg';
import {BaseUser, Image, ResponsiveImage} from '@legit.health/ui';
import Box from '@mui/material/Box';
import {Link} from '@tanstack/react-router';
import ConditionalWrapper from '@/shared/components/ConditionalWrapper';
import {USER_PROFILE} from '@/shared/routing/paths';

export default function UserImage({
  user,
  linked = true,
  filter = true,
  to
}: {
  user: BaseUser;
  linked?: boolean;
  filter?: boolean;
  to?: string;
}) {
  if (user.image) {
    return (
      <ConditionalWrapper
        condition={linked ?? false}
        wrapper={(children: ReactNode) => <Link to={to ?? USER_PROFILE}>{children}</Link>}
      >
        <ResponsiveImage
          sx={{
            borderRadius: 3,
            boxShadow: '2px 10px 15px rgba(0,0,0,0.1)',
            pointerEvents: 'auto'
          }}
          alt={user.fullname}
          src={user.image}
          centered={false}
        />
      </ConditionalWrapper>
    );
  }
  return (
    <ConditionalWrapper
      condition={linked ?? false}
      wrapper={(children: ReactNode) => <Link to={to ?? USER_PROFILE}>{children}</Link>}
    >
      <Box
        sx={{
          borderRadius: 3,
          overflow: 'hidden',
          '& :hover': {
            filter: filter ? 'brightness(0.66)' : 'none'
          },
          '& img': {
            height: '100%',
            borderRadius: 3,
            boxShadow: '0px 20px 23px rgba(0,0,0,0.13)'
          }
        }}
      >
        <Image src={patient} alt={user.name} />
      </Box>
    </ConditionalWrapper>
  );
}
